import { render, staticRenderFns } from "./Funcionarios.vue?vue&type=template&id=8129d2de&scoped=true&lang=pug&"
import script from "./Funcionarios.vue?vue&type=script&lang=js&"
export * from "./Funcionarios.vue?vue&type=script&lang=js&"
import style0 from "./Funcionarios.vue?vue&type=style&index=0&id=8129d2de&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8129d2de",
  null
  
)

export default component.exports